import { connect } from 'react-redux';
import { getDisplayLevel } from '../../../helpers/getLevelHelper';
import KYC_ManualFormComponent from './KYC_ManualFormComponent';
import { reduxForm, getFormValues, reset as _reset } from 'redux-form';
import { setUserConfig } from '../../../redux/actions/userActions';
import { setUserConfigForManualKYC } from '../../../redux/actions/kycManualActions';
import { kycLevelFormSelector } from '../../../redux/selectors/kycLevelsSelectors';
var mapStateToProps = function mapStateToProps(state) {
  var _kycLevelFormSelector = kycLevelFormSelector(state),
    verificationLevel = _kycLevelFormSelector.verificationLevel,
    kycConfig = _kycLevelFormSelector.kycConfig,
    alphaPointUserID = _kycLevelFormSelector.alphaPointUserID,
    userName = _kycLevelFormSelector.userName,
    email = _kycLevelFormSelector.email,
    processing = _kycLevelFormSelector.processing;
  var level = getDisplayLevel(kycConfig, verificationLevel + 1);
  return {
    // Component
    level: level,
    formValues: getFormValues('KYC_Manual_Form')(state),
    processing: processing,
    // KYCManualHelpers
    alphaPointUserID: alphaPointUserID,
    email: email,
    currentLevel: verificationLevel,
    userName: userName
  };
};
var mapDispatchToProps = function mapDispatchToProps(dispatch) {
  return {
    submitUserConfig: function submitUserConfig(setUserConfigPayload) {
      return dispatch(setUserConfig(setUserConfigPayload.UserId, setUserConfigPayload.UserName, setUserConfigPayload.Config, false));
    },
    submitInfoManual: function submitInfoManual(setUserConfigForManualKYCPayload) {
      return dispatch(setUserConfigForManualKYC(setUserConfigForManualKYCPayload.UserId, setUserConfigForManualKYCPayload.UserName, setUserConfigForManualKYCPayload.underReviewLevel, setUserConfigForManualKYCPayload.Config));
    },
    reset: function reset() {
      return dispatch(_reset('KYC_Manual_Form'));
    }
  };
};
var KYC_ManualForm = reduxForm({
  form: 'KYC_Manual_Form',
  onSubmit: function onSubmit() {}
})(KYC_ManualFormComponent);
export default connect(mapStateToProps, mapDispatchToProps)(KYC_ManualForm);